import REPORT from './Report';

export { REPORT };



// WEBPACK FOOTER //
// src/modules/screens/reporting/HourlyInbound/components/index.js